import React, { useState, useEffect } from 'react';
import Layout from '@/components/layout/Layout';
import Seo from '@/components/common/Seo';
import { useTranslation } from '@/hooks/useTranslation';
import { getCanonicalPath } from '@/lib/seoHelper';

// Importiere alle Sektionen
import HeaderSection from './HeaderSection';
import FilterSection from './FilterSection';
import ListSection from './ListSection';
import ReferencesContactSection from './ContactSection';
import ConfidentialProjects from '@/components/References/ConfidentialProjects';

// Registriere die Übersetzungen
import translations from './translations';
import { registerTranslations } from '@/hooks/useTranslation';

// Registriere die Übersetzungen für diese Seite
registerTranslations('referencesPage', translations);

const ReferencesPage = () => {
  const { t } = useTranslation();
  const [selectedTags, setSelectedTags] = useState<string[]>([]);
  const [searchTerm, setSearchTerm] = useState<string>('');

  // Scroll to top on page load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleTagToggle = (tag: string) => {
    setSelectedTags(prev => 
      prev.includes(tag) 
        ? prev.filter(t => t !== tag) 
        : [...prev, tag]
    );
  };

  const handleClearFilters = () => {
    setSelectedTags([]);
    setSearchTerm('');
  };

  const handleSearchChange = (term: string) => {
    setSearchTerm(term);
  };

  return (
    <>
      <Seo 
        title={t('referencesPage.header.title')}
        description={t('referencesPage.header.description')}
        canonical={getCanonicalPath('/references')}
      />
      <Layout>
        <main>
          <HeaderSection />
          <FilterSection 
            selectedTags={selectedTags} 
            onTagToggle={handleTagToggle} 
            onClearFilters={handleClearFilters}
            searchTerm={searchTerm}
            onSearchChange={handleSearchChange}
          />
          <ListSection 
            selectedTags={selectedTags} 
            searchTerm={searchTerm}
          />
          <ConfidentialProjects />
          <ReferencesContactSection />
        </main>
      </Layout>
    </>
  );
};

export default ReferencesPage; 